import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { GetData } from '../../utils/api';
import './FooterEnhanced.css';

const FooterEnhanced = () => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    loadCategories();
  }, []);

  const loadCategories = async () => {
    try {
      const data = await GetData('/categories');
      setCategories((data.categories || []).slice(0, 5));
    } catch (error) {
      console.error('Error cargando categorías:', error);
    }
  };
  return (
    <footer className="footer-enhanced">
      <div className="container">
        <div className="footer-content">
          <div className="footer-column">
            <h3 className="footer-brand">E-Commerce</h3>
            <p className="footer-description">
              Tu tienda online de confianza. Ofrecemos los mejores productos
              con calidad garantizada y envío rápido.
            </p>
          </div>

          <div className="footer-column">
            <h4 className="footer-title">Comprar</h4>
            <ul className="footer-links">
              <li><Link to="/products">Todos los Productos</Link></li>
              {categories?.map(category => (
                <li key={category.id}>
                  <Link to={`/products?categoryId=${category.id}`}>
                    {category.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-column">
            <h4 className="footer-title">Ayuda</h4>
            <ul className="footer-links">
              <li><Link to="/faq">Preguntas Frecuentes</Link></li>
              {/* <li><Link to="/faq">Estado de Pedido</Link></li> */}
              {/* <li><Link to="/faq">Envíos</Link></li> */}
              <li><Link to="/faq">Devoluciones</Link></li>
              <li><Link to="/contact">Contacto</Link></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4 className="footer-title">Empresa</h4>
            <ul className="footer-links">
              <li><Link to="/about">Sobre Nosotros</Link></li>
              <li><Link to="/contact">Trabaja con Nosotros</Link></li>
              {/* <li><Link to="/faq">Blog</Link></li> */}
              {/* <li><Link to="/about">Prensa</Link></li> */}
              <li><Link to="/terms">Términos y Condiciones</Link></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            © {new Date().getFullYear()} MaxServicios. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default FooterEnhanced;
